/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query";
import type {
  PostApiV1UserUseridTemporaryPasswordMutationRequest,
  PostApiV1UserUseridTemporaryPasswordMutationResponse,
  PostApiV1UserUseridTemporaryPasswordPathParams,
  PostApiV1UserUseridTemporaryPassword400,
  PostApiV1UserUseridTemporaryPassword401,
  PostApiV1UserUseridTemporaryPassword500,
} from "../../types/userCredenciaisController/PostApiV1UserUseridTemporaryPassword.ts";
import { mutationOptions, useMutation } from "@tanstack/react-query";
import { postApiV1UserUseridTemporaryPassword } from "../../clients/userCredenciaisController/postApiV1UserUseridTemporaryPassword.ts";

export const postApiV1UserUseridTemporaryPasswordMutationKey = () =>
  [{ url: "/api/v1/user/:userId/temporary-password" }] as const;

export type PostApiV1UserUseridTemporaryPasswordMutationKey = ReturnType<
  typeof postApiV1UserUseridTemporaryPasswordMutationKey
>;

export function postApiV1UserUseridTemporaryPasswordMutationOptions<
  TContext = unknown,
>(
  config: Partial<
    RequestConfig<PostApiV1UserUseridTemporaryPasswordMutationRequest>
  > & { client?: Client } = {},
) {
  const mutationKey = postApiV1UserUseridTemporaryPasswordMutationKey();
  return mutationOptions<
    PostApiV1UserUseridTemporaryPasswordMutationResponse,
    ResponseErrorConfig<
      | PostApiV1UserUseridTemporaryPassword400
      | PostApiV1UserUseridTemporaryPassword401
      | PostApiV1UserUseridTemporaryPassword500
    >,
    {
      userId: PostApiV1UserUseridTemporaryPasswordPathParams["userId"];
      data?: PostApiV1UserUseridTemporaryPasswordMutationRequest;
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ userId, data }) => {
      return postApiV1UserUseridTemporaryPassword(userId, data, config);
    },
  });
}

/**
 * @description Define a senha temporária para um usuário. A senha é criptografada e a data de definição é registrada. Valida permissão de empresa do operador sobre o usuário alvo. Operadores com perfil Seller ou SellerManager não podem redefinir senhas de usuários com perfil diferente de Básico. **(Requer Authorization para autenticação)**
 * @summary Definir senha temporária do usuário (Requer Authorization para autenticação)
 * {@link /api/v1/user/:userId/temporary-password}
 */
export function usePostApiV1UserUseridTemporaryPassword<TContext>(
  options: {
    mutation?: UseMutationOptions<
      PostApiV1UserUseridTemporaryPasswordMutationResponse,
      ResponseErrorConfig<
        | PostApiV1UserUseridTemporaryPassword400
        | PostApiV1UserUseridTemporaryPassword401
        | PostApiV1UserUseridTemporaryPassword500
      >,
      {
        userId: PostApiV1UserUseridTemporaryPasswordPathParams["userId"];
        data?: PostApiV1UserUseridTemporaryPasswordMutationRequest;
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<
      RequestConfig<PostApiV1UserUseridTemporaryPasswordMutationRequest>
    > & { client?: Client };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    postApiV1UserUseridTemporaryPasswordMutationKey();

  const baseOptions = postApiV1UserUseridTemporaryPasswordMutationOptions(
    config,
  ) as UseMutationOptions<
    PostApiV1UserUseridTemporaryPasswordMutationResponse,
    ResponseErrorConfig<
      | PostApiV1UserUseridTemporaryPassword400
      | PostApiV1UserUseridTemporaryPassword401
      | PostApiV1UserUseridTemporaryPassword500
    >,
    {
      userId: PostApiV1UserUseridTemporaryPasswordPathParams["userId"];
      data?: PostApiV1UserUseridTemporaryPasswordMutationRequest;
    },
    TContext
  >;

  return useMutation<
    PostApiV1UserUseridTemporaryPasswordMutationResponse,
    ResponseErrorConfig<
      | PostApiV1UserUseridTemporaryPassword400
      | PostApiV1UserUseridTemporaryPassword401
      | PostApiV1UserUseridTemporaryPassword500
    >,
    {
      userId: PostApiV1UserUseridTemporaryPasswordPathParams["userId"];
      data?: PostApiV1UserUseridTemporaryPasswordMutationRequest;
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PostApiV1UserUseridTemporaryPasswordMutationResponse,
    ResponseErrorConfig<
      | PostApiV1UserUseridTemporaryPassword400
      | PostApiV1UserUseridTemporaryPassword401
      | PostApiV1UserUseridTemporaryPassword500
    >,
    {
      userId: PostApiV1UserUseridTemporaryPasswordPathParams["userId"];
      data?: PostApiV1UserUseridTemporaryPasswordMutationRequest;
    },
    TContext
  >;
}
